// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__15Ylh","item":"PaymentsMobile_item__2BEdJ","label":"PaymentsMobile_label__2DiVW","amount":"PaymentsMobile_amount__3hfdz"};